import React from 'react';
import { Route, IndexRoute } from 'react-router';
import GuestsList from './guestsList';

export default (
  <Route path="usuarios">
    <Route path="convidados">
      <IndexRoute component={(props) => <GuestsList {...props} />} />
    </Route>
  </Route>
);
